import { render, staticRenderFns } from "./lender-rating-info.vue?vue&type=template&id=879c8330"
import script from "./lender-rating-info.vue?vue&type=script&lang=js"
export * from "./lender-rating-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports